export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15202.6b15859f.jpg";